import DateField from '@pelckmans/elementis/components/date-field';
import { Locale } from 'react-day-picker';
import { nlBE, fr } from 'react-day-picker/locale';
import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

const supportedLanguages = ['nl', 'fr'] as const;
type Language = typeof supportedLanguages[number];

const LOCALE_MAP: Record<Language, Locale> = {
  nl: nlBE,
  fr: fr,
};

function isSupportedLanguage(language: string | undefined): asserts language is Language {
  if (!language || !supportedLanguages.includes(language as Language)) {
    throw new Error(`Unsupported language: ${language}. Supported languages are: ${supportedLanguages.join(', ')}`);
  }
}

type Props = DistributiveOmit<ComponentProps<typeof DateField>, 'locale'>;

export default function LocalizedDateField(props: Props) {
  const {
    i18n: { language },
  } = useTranslation();

  isSupportedLanguage(language);

  return <DateField {...props} locale={LOCALE_MAP[language]} dateMenuZIndex={101} />;
}
